import { App } from "../types/app";

export const myApps: App[] = [
  {
    name: "Record Maker",
    desc: "给你的录屏，加上精美的手机壳",
    icon: "https://is2-ssl.mzstatic.com/image/thumb/Purple124/v4/32/55/c6/3255c608-07f3-c0cf-8d33-fea04051ff70/AppIcon-0-0-1x_U007emarketing-0-0-0-7-0-0-sRGB-0-0-0-GLES2_U002c0-512MB-85-220-0-0.png/460x0w.webp",
    url: {
      ios: "https://apps.apple.com/cn/app/record-maker/id1481680144",
    },
  },
  {
    name: "Card Maker",
    desc: "给你的软件创建一个二维码表情包",
    icon: "https://is5-ssl.mzstatic.com/image/thumb/Purple123/v4/8d/2b/13/8d2b137c-5333-cfdb-0cc2-5d8002ad3f34/AppIcon-0-1x_U007emarketing-0-0-85-220-0-5.png/460x0w.webp",
    url: {
      ios: "https://apps.apple.com/cn/app/card-maker-%E7%BB%99%E4%BD%A0%E7%9A%84%E8%BD%AF%E4%BB%B6%E5%88%9B%E5%BB%BA%E4%B8%80%E4%B8%AA%E4%BA%8C%E7%BB%B4%E7%A0%81%E8%A1%A8%E6%83%85%E5%8C%85/id1463358762",
    },
  },
  {
    name: "截图构建",
    desc: "快速构建精美的截图",
    icon: "https://is1-ssl.mzstatic.com/image/thumb/Purple113/v4/1c/63/08/1c63080d-92f7-e77d-8888-0413c5eda19c/AppIcon-0-85-220-0-4-2x.png/460x0w.webp",
    url: {
      macos: "https://apps.apple.com/cn/app/shotbuilder/id1202601197",
    },
  },
  {
    name: "图标构建",
    desc: "让你的软件图标符合规范，就是那么简单",
    icon: "https://is4-ssl.mzstatic.com/image/thumb/Purple124/v4/ea/3b/e3/ea3be344-9038-0f99-d828-7325528965e0/AppIcon-0-85-220-0-4-2x.png/460x0w.webp",
    url: {
      macos: "https://apps.apple.com/cn/app/assetsbuilder/id1294179975",
    },
  },
  {
    name: "Kana Gana",
    desc: "Learn Japanese Syllabary",
    icon: "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/b3/9e/39/b39e39f7-79e8-7742-b7f1-aa27ba57c6f3/AppIcon-0-0-1x_U007emarketing-0-6-0-0-85-220.png/246x0w.png",
    url: {
      ios: "https://apps.apple.com/cn/app/assetsbuilder/id1338600990",
    },
  },
];
